import { MenuItem, TextField } from "@mui/material";
import * as React from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { userActions } from "../../../redux/reducers/UserReducer";
import store from "../../../redux/Store";
import classes from "./SitesDropdown.module.css";
import { commonActions } from "../../../redux/reducers/CommonReducer";
import { getFilteredScopesList, getIconByScope, getSiteByScopeId, getSitesUnderSelectedScope } from "../../../utils/UsersUtils";
import * as actionsService from "../../../services/ActionsService/ActionsService";
import * as encryptedLocalStorageActions from "../../../managers/Storage/EncryptedLocalStorageActions";
import { CLIENT_ROUTES, LOCAL_STORAGE_ITEMS_KEYS, SCOPE_TYPE } from "../../../enums/Enums";
import { refreshAllUsersData } from "../../../services/ParkerService";

const ScopesDropdown = () => {
  const allScopes = useSelector((state) => state.user?.allScopes);
  const userScopes = useSelector((state) => {
    return getFilteredScopesList(state?.user?.scopes, state?.user?.initialState?.roles, state?.user?.gmtUser?.userIdentity?.id)
    //return state.user?.scopes;
  });
  const isShowLoadingSpinner = useSelector(
    (state) => state.common.isShowLoadingSpinner
  );

  let navigate = useNavigate();
  const location = useLocation();
  // const isFirstTimeLoading = useSelector(
  //   (state) => state.common.isFirstTimeLoading
  // );

  const [isFirstTimeScopeLoading, setIsFirstTimeScopeLoading] = useState(true);
  const currentUsersScopes = useSelector((state) => state.user.currentUsersScopes); 

  const selectedScope = useSelector((state) => {
    return state.user?.selectedScope;
  });
  const selectedSite = useSelector((state) => {
    return state.user?.selectedSite;
  });
  const sites = useSelector((state) => {
    return state.user?.sites;
  });
  //const [scope, setScope] = React.useState(selectedScope);

  // React.useEffect(() => {
  //   //setScope(scope);

  // actionsService.getScopeByScopeId(scope?.id, true, false).then((response) => {
  //     store.dispatch(userActions.setCurrentUsersScopes(response.data.entity));
  //   }).then(() => {
  //     store.dispatch(userActions.setUsersScope(scope?.id));
  //   }).catch(() => {

  //   });


  // }, [scope]);

  React.useEffect(() => {    
    if (selectedScope?.id /* && (!isFirstTimeScopeLoading || (currentUsersScopes?.length === 0 && isFirstTimeScopeLoading) || isFirstTimeLoading)*/) { 
      encryptedLocalStorageActions.setStorageItem(LOCAL_STORAGE_ITEMS_KEYS.SELECTED_SCOPE_PERSIST, selectedScope);
      actionsService.getScopeByScopeId(selectedScope?.id, true, false)
        .then((response) => {
          store.dispatch(userActions.setCurrentUsersScopes(response.data.entity));
          store.dispatch(userActions.setUsersScope(selectedScope?.id));          
          const scopesIds = response.data.entity.map(scope => scope.id);
          const isAdminPage = window.location.pathname === CLIENT_ROUTES.ADMIN;
          
          if (isAdminPage) {
            isFirstTimeScopeLoading && setIsFirstTimeScopeLoading(false);
          } else {
            return refreshAllUsersData(
              scopesIds,
              response.data.entity  // Pass full array to filter sites correctly
            ).then(() => {            
              isFirstTimeScopeLoading && setIsFirstTimeScopeLoading(false);
              
              if (window.location.pathname !== CLIENT_ROUTES.PARKERS &&
                window.location.pathname !== CLIENT_ROUTES.ADMIN &&
                window.location.pathname !== CLIENT_ROUTES.ALLOCATIONS) {
                store.dispatch(commonActions.setIsShowLoadingSpinner(false));
              }            
            });
          }
        }).catch((error) => {
          console.log(error);
        })
    }

    // if (selectedScope && (!scope || scope !== selectedScope)) {
    //   //store.dispatch(commonActions.setIsFirstTimeLoading(true));
    //   setScope(selectedScope);
    // }
  }, [selectedScope?.id]);

  const handleChange = (event) => {
    let scope = userScopes?.find((userScope) => userScope.id === event.target.value);
    let selectedSites = getSitesUnderSelectedScope(sites, allScopes, scope);
    let sitesHasBillingEnabled = selectedSites?.some(site => site.isBillingEnabled);
    let sitesHasMessagingEnabled = selectedSites?.some(site => site?.isMessagingEnabled);

    store.dispatch(userActions.setSelectedScope(scope));
    store.dispatch(commonActions.setIsFirstTimeLoading(true));

    // check if trying to reach a site without billing while on '/Billing' route, if yes redirect to parkers
    if (!sitesHasBillingEnabled && window.location.pathname === CLIENT_ROUTES.BILLING) {
      navigate(CLIENT_ROUTES.PARKERS);
    }

    // check if trying to reach messaging route to a non-project scope or reaching a site with no messaging enabled, if yes redirect to parkers
    if ((scope.type !== SCOPE_TYPE.PROJECT || !sitesHasMessagingEnabled) && window.location.pathname === CLIENT_ROUTES.MESSAGING) {
      navigate(CLIENT_ROUTES.PARKERS);
    }

    //setScope(scope);
  };
  // const getSiteByScopeId = (scopeId) => {
  //   return sites.find(site => site.scopeId === scopeId);
  // };

  // Hide dropdown on Dashboard route
  if (location.pathname === CLIENT_ROUTES.DASHBORAD) {
    return null;
  }

  return (
    <div className={classes.sites}>
      <TextField
        select
        label={"Chosen Scope"}
        id={selectedScope ? selectedScope.id : ""}
        name={selectedScope ? selectedScope.name : ""}
        className={classes.box}
        value={selectedScope ? selectedScope?.id : ""}
        onChange={handleChange}
        InputLabelProps={{ classes: { root: classes.label }, shrink: true }}
        InputProps={{
          classes: { notchedOutline: classes.noBorder, input: classes.input },
        }}
        SelectProps={{
          renderValue: (scopeId) => {
            let scope = userScopes?.find((userScope) => userScope.id === scopeId);
            if (scope) {
              let site = getSiteByScopeId(sites, scope.id)//selectedSite.scopeId === scope.id ? selectedSite : null; 
              return (
                <div>
                  {site ? `${site.displayName}` : scope.name}
                </div>
              );
            }
          },
          MenuProps: {
            classes: {
              list: classes.menuList,
              paper: classes.menuPaper,
            },
          },
        }}
      >
        {userScopes &&
          userScopes.map((scope) => {
            const site = getSiteByScopeId(sites, scope.id);
            return (
              <MenuItem key={scope.id} value={scope.id}>
                {getIconByScope(sites, scope, classes.siteIcon)}
                <div className={classes.cardInfo}>
                  <span className={classes.siteName}>{site ? site.displayName : scope.name}</span>
                  <span className={classes.siteAddress}>{site ? site.address : null}</span>
                </div>
              </MenuItem>
            );
          })}
      </TextField>
    </div>
  );
};

export default ScopesDropdown;
